import { css, keyframes } from '@emotion/css';
import React from 'react';
import { ReactComponent as Island } from '../../assets/images/img_image_tutorial_island.svg';
import { reveal } from '../shared/keyframe-animations';
import { FadeRoute } from '../shared/routes/FadeRoute';
import { WaveHeadPattern } from '../shared/WaveHeadPattern';
import { WalkthroughFirst } from './WalkThroughFirst';
import { WalkthroughSecond } from './WalkthroughSecond';

const slideX = keyframes`
  from { transform: translateX(-64px); }
  to { transform: none; }
`;

const Walkthrough: React.FC = () => {
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        position: relative;

        main {
          width: 100%;
          height: 100%;
          max-width: 480px;
          position: relative;
        }
        .content {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
        }
        .island {
          position: absolute;
          left: 0;
          bottom: calc(22vh - 48px);
          transform: translateY(-4px);
          animation: ${reveal} 1s ease-in-out infinite alternate;
        }
        .wave {
          display: flex;
          flex-direction: column;
          position: absolute;
          width: 200%;
          height: 22vh;
          left: 0;
          right: 0;
          bottom: 0;
          animation: ${slideX} 2s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .island,
          .wave {
            animation: none;
          }
        }
      `}
    >
      <main>
        <div className="content">
          <FadeRoute path="/walkthrough/1">
            <WalkthroughFirst />
          </FadeRoute>
          <FadeRoute path="/walkthrough/2">
            <WalkthroughSecond />
          </FadeRoute>
        </div>
        <div className="island">
          <Island />
        </div>
      </main>
      <div className="wave">
        <WaveHeadPattern fillColor={'#acd7e4'} />
      </div>
    </div>
  );
};

export default Walkthrough;
